import { IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ReactNode } from 'react';
import React from 'react';

const TitleWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(p) => p.theme.spacing(1)};
`;

const Title = styled('h2', {
  shouldForwardProp: (prop) =>
    typeof prop === 'string' ? !prop.startsWith('$') : true,
})<{ $bold?: boolean; $uppercase?: boolean }>`
  text-transform: ${(p) => (p.$uppercase ? 'uppercase' : 'none')};
  font-weight: ${(p) => (p.$bold ? 'bold' : 'normal')};
  align-self: center;
  font-size: 20px;
  margin: 0;
  margin-right: 8px;
`;

type Props = {
  testId?: string;
  title: string;
  trailing: ReactNode;
  bold?: boolean;
  uppercase?: boolean;
};

export const createCloseButton = (onClose: () => void): React.ReactNode => {
  return (
    <IconButton onClick={onClose} sx={{ paddingRight: 0.5 }}>
      <CloseIcon />
    </IconButton>
  );
};

const SidePanelHeader = ({
  title,
  testId,
  trailing,
  bold = true,
  uppercase = false,
}: Props) => {
  return (
    <TitleWrapper>
      <Title data-testid={testId} $bold={bold} $uppercase={uppercase}>
        {title}
      </Title>
      {trailing}
    </TitleWrapper>
  );
};

export default SidePanelHeader;
